import React, { Component } from "react";
import { connect } from "react-redux";

import MediaListComponent from "./MediaListComponent";

export class MediaList extends Component {
  render() {
    return <MediaListComponent {...this.props} />;
  }
}
// Connected Component
const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MediaList);



// WEBPACK FOOTER //
// ./src/components/Common/MediaList/index.js